<template>
  <div class="search-box-open float-left">
    <a class="d-block" href="#" @click.prevent="click">
      <transition name="fade-full" mode="out-in">
        <img
          :src="addOthersActiveIcon"
          class="search-icon"
          alt="img"
          v-if="showAdd"
          key="1"
        />
        <img
          :src="addOthersIcon"
          class="search-icon"
          alt="img"
          v-else
          key="2"
        />
      </transition>
    </a>
  </div>
</template>

<script>
export default {
  data() {
    return {
      addOthersIcon: require("../../assets/img/m_add-person.png"),
      addOthersActiveIcon: require("../../assets/img/m_add-person-active.png")
    };
  },
  props: {
    click: Function,
    showAdd: Boolean
  }
};
</script>

<style scoped>
img {
  max-width: 30px;
}

.fade-full-enter {
  opacity: 0;
}

/* stage 2. Entered */
.fade-full-enter-active {
  transition: opacity 0.1s ease-in-out;
}

/* stage 3. leave */
.fade-full-leave-active {
  opacity: 0;
  transition: opacity 0.1s ease-in-out;
}
</style>
